<template>
  <div
    :class="{'form-actions--without-spacer': hideSpacer}"
    class="form-actions"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FormActions',
  props: {
    hideSpacer: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="sass">
@import '~styles/imports'

.form-actions
  +clearfix
  align-items: center
  border-top: 1px solid $color-grey-1
  display: flex
  margin-top: rem-calc(50)
  padding-top: rem-calc(50)

  &--without-spacer
    border: 0
    margin-top: rem-calc(15)
    padding-top: 0

  > *
    margin-right: 30px

  .button-input[name="cancel"]
    +font-size(14, 16)
    color: rgba($color-black, 0.5)
    font-weight: 600
    margin-left: auto

  .cancel
    +font-size(14, 16)
    color: rgba($color-black, 0.5)
    cursor: pointer
    font-weight: 600
    margin-left: auto
    user-select: none

  .modal &
    +respond-min($md)
      margin: rem-calc(40 (-40) (-40))
      padding: rem-calc(40)

    +respond-max($md)
      margin: rem-calc(20 (-20) (-20))
      padding: rem-calc(20)

    background: $color-grey-1
    border-top: 1px solid darken($color-grey-1, 5%)
    border-radius: 0 0 $border-radius $border-radius
</style>



// WEBPACK FOOTER //
// src/components/forms/FormActions.vue